require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./flexlayout"), require("./numberinput"), require("./tooltip"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./flexlayout", "./numberinput", "./tooltip", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./flexlayout"), require("./numberinput"), require("./tooltip"), require("./utils")) : factory(root["./flexlayout"], root["./numberinput"], root["./tooltip"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__11880__, __WEBPACK_EXTERNAL_MODULE__65391__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[309],{

/***/ 57363:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _Slider = _interopRequireDefault(__webpack_require__(6696));
var _TooltipWrapper = _interopRequireDefault(__webpack_require__(40906));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
class Handle extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      showFocusClass: false
    });
    (0, _defineProperty2.default)(this, "_onFocus", () => {
      this.setState({
        showFocusClass: true
      });
    });
    (0, _defineProperty2.default)(this, "_onBlur", () => {
      this.setState({
        showFocusClass: false
      });
    });
  }
  render() {
    const {
      className,
      handleRef,
      value,
      style,
      onKeyDown,
      onMouseDown,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      showTooltip,
      labelFormatter,
      inverted
    } = this.props;
    const containerProps = {
      className: (0, _utils.classnames)(`${sliderClassName}__handle`, `${className}`),
      ref: node => {
        this._containerRef = node;
      },
      style,
      showTooltip,
      orient: 'top',
      title: labelFormatter(value)
    };
    const handleProps = {
      className: (0, _utils.classnames)(`${sliderClassName}__handle__input`, {
        focus: this.state.showFocusClass,
        inverted
      }),
      ref: handleRef,
      onMouseDown,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      onKeyDown,
      tabIndex: 0,
      onKeyUp: this._onFocus,
      onBlur: this._onBlur
    };
    return /*#__PURE__*/_react.default.createElement(_TooltipWrapper.default, containerProps, /*#__PURE__*/_react.default.createElement("div", handleProps));
  }
}
exports["default"] = Handle;
(0, _defineProperty2.default)(Handle, "propTypes", {
  className: _propTypes.default.string,
  handleRef: _propTypes.default.func,
  value: _propTypes.default.number.isRequired,
  style: _propTypes.default.object,
  showTooltip: _propTypes.default.bool,
  labelFormatter: _propTypes.default.func.isRequired,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onTouchStart: _propTypes.default.func,
  onTouchMove: _propTypes.default.func,
  onTouchEnd: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  inverted: _propTypes.default.bool
});

/***/ }),

/***/ 89617:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _Handle = _interopRequireDefault(__webpack_require__(57363));
var _Track = _interopRequireDefault(__webpack_require__(5968));
var _Slider = _interopRequireDefault(__webpack_require__(6696));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
class Range extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      trackDragging: false,
      handleDragging: false
    });
    (0, _defineProperty2.default)(this, "_moveClosestHandleToMouse", e => {
      if (this.props.disabled) return;
      const {
        values,
        onChange,
        min
      } = this.props;
      const {
        left
      } = this._getSliderPosition();
      const newValue = min + this._calculateValueOffset(this._getMouseOrTouchPosition(e) - left);
      const activeHandle = this._getClosestHandleIndex(values, newValue);
      values[activeHandle] = newValue;
      this._handleRefs[activeHandle].focus();
      onChange && onChange(values);
    });
    (0, _defineProperty2.default)(this, "_onTrackDragStart", e => {
      if (this.props.disabled) return;
      _utils.event.stopEvent(e);
      this.setState({
        trackDragging: true
      });
      this.prevTrackPos = this._getMouseOrTouchPosition(e);
      if (this._isTouchEvent(e)) {
        this._trackRef.addEventListener('touchend', this._onTrackDragDone);
        this._trackRef.addEventListener('touchmove', this._onTrackDragging);
      } else {
        this._trackRef.addEventListener('mouseup', this._moveClosestHandleToMouse);
        window.addEventListener('mouseup', this._onTrackDragDone);
        window.addEventListener('mousemove', this._onTrackDragging);
      }
    });
    (0, _defineProperty2.default)(this, "_onTrackKeyDown", e => {
      if (this.props.disabled) return;
      const keyName = _utils.keyboardUtils.getKeyName(e);
      const {
        TAB
      } = _utils.keyboardUtils.keyNames;
      if (keyName === TAB) {
        return;
      }
      _utils.event.stopEvent(e);
      const {
        values,
        onChange,
        onInputComplete,
        step,
        min,
        max
      } = this.props;
      const offset = this._getKeyValueOffset(keyName, step);
      if (offset < 0 && values[0] > min || offset > 0 && values[1] < max) {
        onChange && onChange(values.map(value => _utils.mathUtils.decimalPlus(value, offset)));
        onInputComplete && onInputComplete();
      }
    });
    (0, _defineProperty2.default)(this, "_onHandleKeyDown", (e, index) => {
      if (this.props.disabled) return;
      const keyName = _utils.keyboardUtils.getKeyName(e);
      const {
        TAB
      } = _utils.keyboardUtils.keyNames;
      if (keyName === TAB) {
        return;
      }
      _utils.event.stopEvent(e);
      const {
        values,
        onChange,
        onInputComplete,
        step,
        min,
        max
      } = this.props;
      const copyValues = [...values];
      const offset = this._getKeyValueOffset(keyName, step);
      copyValues[index] = _utils.mathUtils.decimalPlus(copyValues[index], offset);
      if (min <= copyValues[0] && copyValues[0] <= copyValues[1] && copyValues[1] <= max) {
        onChange && onChange(copyValues);
        onInputComplete && onInputComplete();
      }
    });
    (0, _defineProperty2.default)(this, "_onTrackDragging", e => {
      if (this.props.disabled) return;
      _utils.event.stopEvent(e);
      const {
        values,
        onChange,
        min,
        max
      } = this.props;
      const mousePos = this._getMouseOrTouchPosition(e);
      const valueOffset = this._calculateValueOffset(mousePos - this.prevTrackPos);
      // Only update if we move mouse enough to have a change in value
      if (valueOffset !== 0) {
        this._trackRef.removeEventListener('mouseup', this._moveClosestHandleToMouse);
        this._trackRef.focus();
        this.prevTrackPos = mousePos;
        const postValues = values.map(v => _utils.mathUtils.decimalPlus(v, valueOffset));
        if (postValues[0] >= min && postValues[1] <= max) {
          onChange && onChange(postValues, min, max);
        }
      }
    });
    (0, _defineProperty2.default)(this, "_onTrackDragDone", () => {
      this._removeEventListener();
      this.setState({
        trackDragging: false
      });
      delete this.prevTrackPos;
      this.props.onInputComplete && this.props.onInputComplete();
    });
    (0, _defineProperty2.default)(this, "_onHandleDragStart", (e, index) => {
      if (this.props.disabled) return;
      _utils.event.stopEvent(e);
      this._handleRefs[index].focus();
      this.setState({
        handleDragging: true
      });
      this.activeHandleIndex = index;
      if (this._isTouchEvent(e)) {
        this._handleRefs[index].addEventListener('touchend', this._onHandleDragDone);
        this._handleRefs[index].addEventListener('touchmove', this._onHandleDragging);
      } else {
        window.addEventListener('mouseup', this._onHandleDragDone);
        window.addEventListener('mousemove', this._onHandleDragging);
      }
    });
    (0, _defineProperty2.default)(this, "_onHandleDragging", e => {
      if (this.props.disabled) return;
      _utils.event.stopEvent(e);
      const {
        values,
        onChange,
        min,
        max
      } = this.props;
      const {
        left
      } = this._getSliderPosition();
      const newValue = min + this._calculateValueOffset(this._getMouseOrTouchPosition(e) - left);
      if (this.activeHandleIndex === 0) {
        values[0] = newValue > values[1] ? values[1] : newValue;
      } else {
        values[1] = newValue < values[0] ? values[0] : newValue;
      }
      onChange && onChange(this._ensureValuesWithinRange(values, min, max));
    });
    (0, _defineProperty2.default)(this, "_onHandleDragDone", () => {
      this._removeEventListener();
      this.setState({
        handleDragging: false
      });
      delete this.activeHandleIndex;
      this.props.onInputComplete && this.props.onInputComplete();
    });
    (0, _defineProperty2.default)(this, "_onRailClick", e => {
      if (this.props.disabled) return;
      const {
        values,
        min
      } = this.props;
      const {
        left
      } = this._getSliderPosition();
      const newValue = min + this._calculateValueOffset(this._getMouseOrTouchPosition(e) - left);
      const activeHandle = this._getClosestHandleIndex(values, newValue);
      this._moveClosestHandleToMouse(e);
      this._onHandleDragStart(e, activeHandle);
    });
    this._handleRefs = new Array(2);
  }
  componentWillUnmount() {
    this._removeEventListener();
  }
  _removeEventListener() {
    if (this.state.trackDragging) {
      window.removeEventListener('mousemove', this._onTrackDragging);
      window.removeEventListener('mouseup', this._onTrackDragDone);
      this._trackRef.removeEventListener('touchmove', this._onTrackDragging);
      this._trackRef.removeEventListener('touchend', this._onTrackDragDone);
    }
    if (this.state.handleDragging) {
      window.removeEventListener('mousemove', this._onHandleDragging);
      window.removeEventListener('mouseup', this._onHandleDragDone);
      this._handleRefs.forEach(handle => {
        handle.removeEventListener('touchmove', this._onHandleDragging);
        handle.removeEventListener('touchend', this._onHandleDragDone);
      });
    }
    this._trackRef.removeEventListener('mouseup', this._onTrackClick);
  }
  _toPercentage(value, min, max) {
    return Math.round((value - min) / (max - min) * 100);
  }
  _getMouseOrTouchPosition(e) {
    return e.pageX || e.touches[0].pageX;
  }
  _isTouchEvent(e) {
    return e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend';
  }
  _ensureValuesWithinRange(values, min, max) {
    return values.map(v => {
      if (v < min) {
        return min;
      } else if (v > max) {
        return max;
      }
      return v;
    });
  }
  _calculateValueOffset(offset) {
    const {
      step,
      min,
      max
    } = this.props;
    const {
      width
    } = this._getSliderPosition();
    const stepsTotal = Math.round((max - min) / step);
    const stepWidth = width / stepsTotal;
    return _utils.mathUtils.decimalMultiply(Math.round(offset / stepWidth), step);
  }
  _getSliderPosition() {
    return {
      left: _utils.domUtils.computeLeftWith(this._sliderRef),
      width: _utils.domUtils.computeWidthOf(this._sliderRef)
    };
  }
  _getKeyValueOffset(keyName, step) {
    const {
      LEFT,
      RIGHT,
      UP,
      DOWN
    } = _utils.keyboardUtils.keyNames;
    if (keyName === LEFT || keyName === DOWN) {
      return -step;
    } else if (keyName === RIGHT || keyName === UP) {
      return step;
    }
    return 0;
  }
  _getClosestHandleIndex(values, newValue) {
    if (values[0] !== values[1]) {
      return Math.abs(newValue - values[0]) < Math.abs(newValue - values[1]) ? 0 : 1;
    }
    return newValue - values[0] > 0 ? 1 : 0;
  }
  render() {
    const {
      values,
      min,
      max,
      className,
      onMouseEnter,
      onMouseLeave,
      showTooltip,
      labelFormatter,
      setFocus,
      setBlur,
      inverted
    } = this.props;
    const {
      trackDragging,
      handleDragging
    } = this.state;
    const containerProps = {
      className: `${className}`,
      ref: node => {
        this._sliderRef = node;
      },
      onMouseDown: this._onRailClick,
      // Need to stop touch event to avoid triggering mouse simulation events
      onTouchStart: e => _utils.event.stopEvent(e),
      onTouchEnd: e => _utils.event.stopEvent(e)
    };
    const valuesAsPercent = values.map(value => this._toPercentage(value, min, max));
    const railProps = {
      className: `${sliderClassName}__rail${inverted ? ' is-inverted' : ''}`
    };
    const trackProps = {
      trackRef: node => {
        this._trackRef = node;
      },
      values,
      labelFormatter,
      showTooltip: showTooltip && !this.state.handleDragging,
      style: {
        left: `${valuesAsPercent[0]}%`,
        width: `${valuesAsPercent[1] - valuesAsPercent[0]}%`
      },
      onMouseDown: this._onTrackDragStart,
      onTouchStart: this._onTrackDragStart,
      onKeyDown: this._onTrackKeyDown,
      setFocus,
      setBlur,
      inverted
    };
    const handlesProps = valuesAsPercent.map((value, index) => ({
      className: (0, _utils.classnames)(`handle-${index}`),
      handleRef: node => {
        this._handleRefs[index] = node;
      },
      style: {
        left: `${value}%`
      },
      value: values[index],
      showTooltip: showTooltip && !trackDragging && (!handleDragging || this.activeHandleIndex === index),
      labelFormatter,
      onMouseDown: e => this._onHandleDragStart(e, index),
      onTouchStart: e => {
        e.preventDefault();
        this._onHandleDragStart(e, index);
      },
      onKeyDown: e => this._onHandleKeyDown(e, index),
      onMouseEnter,
      onMouseLeave,
      inverted
    }));
    const stepProps = {
      className: `${sliderClassName}__step`
    };
    return /*#__PURE__*/_react.default.createElement("div", containerProps, /*#__PURE__*/_react.default.createElement("div", railProps), /*#__PURE__*/_react.default.createElement("div", stepProps, /*#__PURE__*/_react.default.createElement(_Track.default, trackProps), /*#__PURE__*/_react.default.createElement(_Handle.default, handlesProps[0]), /*#__PURE__*/_react.default.createElement(_Handle.default, handlesProps[1])));
  }
}
exports["default"] = Range;
(0, _defineProperty2.default)(Range, "propTypes", {
  values: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  min: _propTypes.default.number.isRequired,
  max: _propTypes.default.number.isRequired,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  step: _propTypes.default.number.isRequired,
  showTooltip: _propTypes.default.bool,
  labelFormatter: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onInputComplete: _propTypes.default.func.isRequired,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onTouchStart: _propTypes.default.func,
  onTouchEnd: _propTypes.default.func,
  setFocus: _propTypes.default.func,
  setBlur: _propTypes.default.func,
  inverted: _propTypes.default.bool,
  disabled: _propTypes.default.bool
});

/***/ }),

/***/ 32487:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _numberinput = _interopRequireDefault(__webpack_require__(11880));
var _flexlayout = _interopRequireWildcard(__webpack_require__(77765));
var _Range = _interopRequireDefault(__webpack_require__(89617));
var _Slider = _interopRequireDefault(__webpack_require__(6696));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

let lang = 'en';
if (document.documentElement && document.documentElement.lang) {
  lang = document.documentElement.lang;

  // The locale key for Norwegian differs between Cognos and Moment
  if (lang === 'no') {
    lang = 'nb';
  }
}
const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
const rangeSliderFlag = _Slider.default.rangeSliderFlag.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
const MAX_NUMBER_DECIMAL = 17;
const getFormatted = (value, scale) => Number(Number(value).toFixed(scale));
class RangeSlider extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      showFocusClass: false
    });
    (0, _defineProperty2.default)(this, "_focus", () => {
      this.numberInput.current && this.numberInput.current.focus();
    });
    (0, _defineProperty2.default)(this, "_setFocus", () => {
      this.setState({
        showFocusClass: true
      });
    });
    (0, _defineProperty2.default)(this, "_setBlur", () => {
      this.setState({
        showFocusClass: false
      });
    });
    (0, _defineProperty2.default)(this, "_sliderContainerRef", node => {
      this._sliderContainer = node;
    });
    (0, _defineProperty2.default)(this, "_getValidatedValues", values => values.map((v, i) => isNaN(v) ? this.state.values[i] : Number(v)));
    (0, _defineProperty2.default)(this, "_onChange", values => {
      const {
        min,
        max,
        onChange
      } = this.props;
      const validatedValues = this._getValidatedValues(values);
      this.setState({
        min: Math.min(validatedValues[0], min),
        max: Math.max(validatedValues[1], max),
        values: validatedValues
      });
      onChange && onChange(validatedValues);
    });
    this.numberInput = (0, _react.createRef)();
  }
  componentWillMount() {
    this._getDerivedStateFromProps(this.props);
  }
  componentDidMount() {
    if (this.props.autoFocus) {
      this._focus();
    }
  }
  componentWillReceiveProps(nextProps) {
    this._getDerivedStateFromProps(nextProps);
  }
  // The reason why we cannot use React one is that explore remount range slider every time prop change.
  _getDerivedStateFromProps(props) {
    const {
      min,
      max,
      values: propValues
    } = props;
    const values = propValues && propValues.length === 2 ? propValues : [min, max];
    this.setState({
      values,
      min: Math.min(values[0], min),
      max: Math.max(values[1], max)
    });
  }
  _getDir() {
    const dir = document.querySelector('[dir="rtl"]') ? 'right' : 'left';
    return dir;
  }

  // numberInput returns undefined with blank input

  _toPercentage(value, min, max) {
    return Math.round((value - min) / (max - min) * 100);
  }
  _renderHandleLabel(props) {
    const dir = this._getDir();
    const {
      value,
      index
    } = props;
    const {
      min,
      max
    } = this.state;
    const {
      labelFormatter,
      scale
    } = this.props;
    const positionsOnTrackPercent = this._toPercentage(value, min, max);
    const handleLabelStyle = {};
    handleLabelStyle[dir] = `${positionsOnTrackPercent}%`;
    return /*#__PURE__*/_react.default.createElement("p", {
      key: index,
      style: handleLabelStyle,
      className: `${sliderClassName}__handle_label ${rangeSliderFlag}`
    }, labelFormatter(value, scale));
  }
  render() {
    const {
      id,
      step,
      disabled,
      light,
      labelFormatter,
      showHandleLabel,
      showInputBox,
      showBoundaryLabels,
      showTooltip,
      size,
      className,
      style,
      onInputComplete,
      inverted,
      scale,
      ...others
    } = this.props;
    const {
      min,
      max,
      values,
      showFocusClass
    } = this.state;
    const containerProps = {
      className: `${sliderClassName} ${className}`,
      style
    };
    const sliderContainerProps = {
      className: (0, _utils.classnames)(`${sliderClassName}__container`, {
        focus: showFocusClass,
        disabled,
        handleLabelled: showHandleLabel,
        boundaryLabelled: showBoundaryLabels
      }),
      ref: this._sliderContainerRef,
      style
    };
    const boundaryLabelProps = {
      className: `${sliderClassName}__boundary_label`
    };
    const sliderProps = {
      ...sanitize(others, RangeSlider),
      className: (0, _utils.classnames)(`${sliderClassName}__container__input`, rangeSliderFlag, inverted, {
        [size]: size
      }),
      allowCross: false,
      values,
      min,
      max,
      id,
      step,
      disabled,
      showTooltip,
      labelFormatter: value => labelFormatter(value, scale),
      onChange: this._onChange,
      onInputComplete,
      tabIndex: -1,
      setFocus: this._setFocus,
      setBlur: this._setBlur,
      inverted
    };
    const renderLeftLabel = () => /*#__PURE__*/_react.default.createElement("div", boundaryLabelProps, labelFormatter(min, scale));
    const renderRightLabel = () => /*#__PURE__*/_react.default.createElement("div", boundaryLabelProps, labelFormatter(max, scale));
    const renderInputBox = () => showInputBox ? /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      gutter: [0, 0, 5, 0]
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      direction: "row"
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true
    }, /*#__PURE__*/_react.default.createElement(_numberinput.default, {
      scale: MAX_NUMBER_DECIMAL,
      disabled: disabled,
      light: light,
      step: step,
      max: values[1],
      fullWidth: true,
      value: values[0],
      onValueAccept: val => this._onChange([val, values[1]]),
      locale: lang,
      ref: this.numberInput
    })), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      style: {
        width: '1rem'
      }
    }), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true
    }, /*#__PURE__*/_react.default.createElement(_numberinput.default, {
      scale: MAX_NUMBER_DECIMAL,
      disabled: disabled,
      light: light,
      step: step,
      min: values[0],
      fullWidth: true,
      value: values[1],
      onValueAccept: val => this._onChange([values[0], val]),
      locale: lang
    })))) : null;
    const renderBoundaryLabel = () => showInputBox && showBoundaryLabels ? /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      gutter: [1, 0, 0, 0]
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      direction: "row"
    }, /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, renderLeftLabel()), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      grow: true
    }), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, null, renderRightLabel()))) : null;
    return /*#__PURE__*/_react.default.createElement(_flexlayout.default, {
      direction: "column"
    }, renderInputBox(), /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", containerProps, showBoundaryLabels && !showInputBox ? renderLeftLabel() : null, /*#__PURE__*/_react.default.createElement("div", sliderContainerProps, showHandleLabel && /*#__PURE__*/_react.default.createElement("div", {
      className: `${sliderClassName}__handle_label_container ${rangeSliderFlag}`
    }, values.map((value, index) => this._renderHandleLabel({
      value,
      index
    }))), /*#__PURE__*/_react.default.createElement(_Range.default, sliderProps)), showBoundaryLabels && !showInputBox ? renderRightLabel() : null)), renderBoundaryLabel());
  }
}
exports["default"] = RangeSlider;
(0, _defineProperty2.default)(RangeSlider, "propTypes", {
  /** Minimum possible value for the slider */
  min: _propTypes.default.number,
  /** Maximum possible value for the slider */
  max: _propTypes.default.number,
  /** Function that gets called each time the slider is changed. It provides one parameter, which is the new value of the slider */
  onChange: _propTypes.default.func,
  /** Function that gets called when user completes input */
  onInputComplete: _propTypes.default.func,
  /** ID to give to the slider input */
  id: _propTypes.default.string,
  /** Level of increment for each increase in the slider */
  step: _propTypes.default.number,
  /** Disables the slider if passed */
  disabled: _propTypes.default.bool,
  // Carbon light variant of the component
  light: _propTypes.default.bool,
  /** Some function that is applied to the numeric values to format their labels for the slider. Should return a string */
  labelFormatter: _propTypes.default.func,
  /** Option to show the label on the handle */
  showHandleLabel: _propTypes.default.bool,
  /** Option to show the boundary input box */
  showInputBox: _propTypes.default.bool,
  /** Option to show the min/max labels */
  showBoundaryLabels: _propTypes.default.bool,
  /** Flag to display tooltip */
  showTooltip: _propTypes.default.bool,
  /** Optional size for slider */
  size: _propTypes.default.oneOf(['small', 'medium']),
  /** ClassName to be applied to the slider container */
  className: _propTypes.default.string,
  /** Custom CSS styling */
  style: _propTypes.default.object,
  /** Values in the case of range slider */
  values: _propTypes.default.arrayOf(_propTypes.default.number),
  /** Option to invert the range */
  inverted: _propTypes.default.bool,
  /** Optional, scale for number format */
  scale: _propTypes.default.number,
  /** Optional, auto focus on the first NumberInput */
  autoFocus: _propTypes.default.bool
});
(0, _defineProperty2.default)(RangeSlider, "defaultProps", {
  size: 'medium',
  min: 0,
  max: 100,
  step: 1,
  scale: 3,
  labelFormatter: (value, scale) => getFormatted(value, scale).toLocaleString(lang),
  className: '',
  style: {}
});

/***/ }),

/***/ 77541:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _lodash = __webpack_require__(46517);
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
var _Slider = _interopRequireDefault(__webpack_require__(6696));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
const carbonContainer = _Slider.default.carbonContainer.replace(/"/g, '');
const {
  BaPropTypes
} = _utils.propsUtils;
class Slider extends _react.Component {
  render() {
    const {
      labelFormatter,
      formatLabel,
      onChange,
      className,
      ...rest
    } = this.props;
    const mappedProps = {
      formatLabel: formatLabel || labelFormatter
    };
    const passThrouProps = (0, _lodash.omit)(rest, ['showHandleLabel', 'showBoundaryLabels', 'showTooltip', 'size']);
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Slider, (0, _extends2.default)({
      className: `${className} ${sliderClassName}${carbonContainer}`
    }, mappedProps, passThrouProps, {
      onChange: _ref => {
        let {
          value
        } = _ref;
        return onChange == null ? void 0 : onChange(value);
      }
    }));
  }
}
exports["default"] = Slider;
(0, _defineProperty2.default)(Slider, "propTypes", {
  /**
   * The CSS class name for the slider.
   */
  className: _propTypes.default.string,
  /**
   * `true` to hide the number input box.
   */
  hideTextInput: _propTypes.default.bool,
  /**
   * The ID of the `<input>`.
   */
  id: _propTypes.default.string,
  /**
   * The callback to get notified of change in value.
   */
  onChange: _propTypes.default.func,
  /**
   * The callback to get notified of value on handle release.
   */
  onRelease: _propTypes.default.func,
  /**
   * The value.
   */
  value: _propTypes.default.number.isRequired,
  /**
   * The minimum value.
   */
  min: _propTypes.default.number.isRequired,
  /**
   * The label associated with the minimum value.
   */
  minLabel: _propTypes.default.string,
  /**
   * The maximum value.
   */
  max: _propTypes.default.number.isRequired,
  /**
   * The label associated with the maximum value.
   */
  maxLabel: _propTypes.default.string,
  /**
   *  legacy toolkit prop, map to formatLabel
   */
  labelFormatter: _propTypes.default.func,
  /**
   * The callback to format the label associated with the minimum/maximum value.
   */
  formatLabel: _propTypes.default.func,
  /**
   * The label for the slider.
   */
  labelText: _propTypes.default.node,
  /**
   * A value determining how much the value should increase/decrease by moving the thumb by mouse.
   */
  step: _propTypes.default.number,
  /**
   * A value determining how much the value should increase/decrease by Shift+arrow keys,
   * which will be `(max - min) / stepMultiplier`.
   */
  stepMultiplier: _propTypes.default.number,
  /**
   * The child nodes.
   */
  children: _propTypes.default.node,
  /**
   * `true` to disable this slider.
   */
  disabled: _propTypes.default.bool,
  /**
   * The `name` attribute of the `<input>`.
   */
  name: _propTypes.default.string,
  /**
   * The `type` attribute of the `<input>`.
   */
  inputType: _propTypes.default.string,
  /**
   * The `ariaLabel` for the `<input>`.
   */
  ariaLabelInput: _propTypes.default.string,
  /**
   * `true` to use the light version.
   */
  light: _propTypes.default.bool,
  /** Toolkit Custom CSS styling */
  style: _propTypes.default.object,
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showHandleLabel: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showBoundaryLabels: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showTooltip: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  size: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider)
});
(0, _defineProperty2.default)(Slider, "defaultProps", {
  hideTextInput: true,
  className: ''
});

/***/ }),

/***/ 40906:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _tooltip = __webpack_require__(65391);
var _Slider = _interopRequireDefault(__webpack_require__(6696));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
class TooltipWrapper extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      top: 0,
      // eslint-disable-line react/no-unused-state
      left: 0,
      // eslint-disable-line react/no-unused-state
      width: 0,
      // eslint-disable-line react/no-unused-state
      hover: false,
      touch: false,
      dragging: false
    });
    (0, _defineProperty2.default)(this, "_onMouseEnter", () => {
      this._resetStates();
      this.setState({
        hover: true
      });
    });
    (0, _defineProperty2.default)(this, "_onMouseLeave", () => {
      this.setState({
        hover: false
      });
    });
    (0, _defineProperty2.default)(this, "_onMouseDown", () => {
      this._resetStates();
      this.setState({
        dragging: true
      });
      window.addEventListener('mouseup', this._onMouseUp);
    });
    (0, _defineProperty2.default)(this, "_onTouchStart", () => {
      this.setState({
        touch: true
      });
    });
    (0, _defineProperty2.default)(this, "_onTouchEnd", () => {
      this.setState({
        touch: false
      });
    });
    (0, _defineProperty2.default)(this, "_onMouseUp", () => {
      this.setState({
        dragging: false
      });
    });
  }
  componentDidMount() {
    this._resetStates();
  }
  componentWillReceiveProps() {
    this._resetStates();
  }
  componentWillUnmount() {
    window.removeEventListener('mouseup', this._onMouseUp);
  }
  _resetStates() {
    // Note: 'state' is passed to 'TooltipPopup'
    this.setState({
      top: _utils.domUtils.computeTopWith(this._containerRef),
      // eslint-disable-line react/no-unused-state
      left: _utils.domUtils.computeLeftWith(this._containerRef),
      // eslint-disable-line react/no-unused-state
      width: _utils.domUtils.computeWidthOf(this._containerRef) // eslint-disable-line react/no-unused-state
    });
  }

  render() {
    const {
      className,
      orient,
      title,
      showTooltip,
      children,
      style
    } = this.props;
    const {
      hover,
      dragging,
      touch
    } = this.state;
    const containerProps = {
      className: (0, _utils.classnames)(`${sliderClassName}__tooltip__wrapper`, `${className}`),
      ref: node => {
        this._containerRef = node;
      },
      onMouseDownCapture: this._onMouseDown,
      onTouchStartCapture: this._onTouchStart,
      onTouchEndCapture: this._onTouchEnd,
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      style
    };
    const tooltipProps = {
      orient,
      title,
      triggerState: this.state
    };
    return /*#__PURE__*/_react.default.createElement("div", containerProps, showTooltip && (hover || dragging || touch) && /*#__PURE__*/_react.default.createElement(_tooltip.TooltipPopup, tooltipProps), children);
  }
}
exports["default"] = TooltipWrapper;
(0, _defineProperty2.default)(TooltipWrapper, "propTypes", {
  className: _propTypes.default.string,
  orient: _propTypes.default.string,
  title: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  showTooltip: _propTypes.default.bool,
  style: _propTypes.default.object
});

/***/ }),

/***/ 5968:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _Slider = _interopRequireDefault(__webpack_require__(6696));
var _TooltipWrapper = _interopRequireDefault(__webpack_require__(40906));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const sliderClassName = _Slider.default.sliderClassName.replace(/"/g, '');
class Track extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_onFocus", () => {
      this.props.setFocus();
    });
    (0, _defineProperty2.default)(this, "_onBlur", () => {
      this.props.setBlur();
    });
  }
  render() {
    const {
      className,
      trackRef,
      values,
      style,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      onKeyDown,
      onMouseDown,
      showTooltip,
      labelFormatter,
      inverted
    } = this.props;
    const containerProps = {
      className: (0, _utils.classnames)(`${sliderClassName}__track`, `${className}`),
      ref: node => {
        this._containerRef = node;
      },
      style,
      showTooltip,
      orient: 'top',
      title: `${labelFormatter(values[0])} - ${labelFormatter(values[1])}`
    };
    const trackProps = {
      className: `${sliderClassName}__track__input${inverted ? ' is-inverted' : ''}`,
      ref: trackRef,
      onMouseDown,
      onTouchStart,
      onTouchMove,
      onTouchEnd,
      onKeyDown,
      tabIndex: 0,
      onKeyUp: this._onFocus,
      onBlur: this._onBlur
    };
    return /*#__PURE__*/_react.default.createElement(_TooltipWrapper.default, containerProps, /*#__PURE__*/_react.default.createElement("div", trackProps));
  }
}
exports["default"] = Track;
(0, _defineProperty2.default)(Track, "propTypes", {
  className: _propTypes.default.string,
  trackRef: _propTypes.default.func,
  values: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  style: _propTypes.default.object,
  showTooltip: _propTypes.default.bool,
  labelFormatter: _propTypes.default.func.isRequired,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onTouchStart: _propTypes.default.func,
  onTouchMove: _propTypes.default.func,
  onTouchEnd: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  setFocus: _propTypes.default.func,
  setBlur: _propTypes.default.func,
  inverted: _propTypes.default.bool
});

/***/ }),

/***/ 56751:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Slider = _interopRequireDefault(__webpack_require__(77541));
exports["default"] = _Slider.default;
exports.Slider = _Slider.default;
var _RangeSlider = _interopRequireDefault(__webpack_require__(32487));
exports.RangeSlider = _RangeSlider.default;

/***/ }),

/***/ 61376:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-slider{display:flex;align-items:center;align-self:center;width:100%;position:relative}.ba-common-slider__carbonContainer{min-width:8rem}.ba-common-slider__container{display:inline-block;width:100%;position:relative}.ba-common-slider__container__input{width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;height:2px;vertical-align:middle;cursor:pointer;padding:0;display:inline-block}.ba-common-slider__container__input::-webkit-slider-thumb{-webkit-appearance:none;outline:none;border-radius:50%;width:18px;height:18px}.ba-common-slider__container__input::-ms-thumb{outline:none;border:none;height:18px;width:18px;border-radius:50%}.ba-common-slider__container__input::-moz-range-thumb{-moz-appearance:none;outline:none;border-radius:50%;border:none;width:18px;height:18px}.ba-common-slider__container__input.is-range{height:18px}.ba-common-slider__container__input.is-range .ba-common-slider__rail{position:absolute;width:100%;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step{position:relative;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track{position:absolute;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input{position:absolute;left:0;width:100%;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input:focus{outline:none}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle{position:absolute;top:50%;transform:translateY(-50%)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input{cursor:pointer;cursor:-webkit-grab;cursor:grab;border-radius:50%;-ms-touch-action:pan-x;touch-action:pan-x}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input:focus{outline:none}.ba-common-slider__container__input.is-small::-webkit-slider-thumb{width:12px;height:12px}.ba-common-slider__container__input.is-small::-ms-thumb{height:12px;width:12px}.ba-common-slider__container__input.is-small::-moz-range-thumb{width:12px;height:12px}.ba-common-slider__container__input.is-small .ba-common-slider__handle__input{width:12px;height:12px}.ba-common-slider__container__input.is-small .ba-common-slider__handle__input.is-focus{box-shadow:0 0 0 2px #a8c0f3;box-shadow:0 0 0 2px var(--focus, #a8c0f3);-webkit-box-shadow:0 0 0 2px var(--focus, #a8c0f3);-moz-box-shadow:0 0 0 2px var(--focus, #a8c0f3)}.ba-common-slider__container__input.is-small .ba-common-slider__step{width:calc(100% - 12px)}.ba-common-slider__container__input.is-small .ba-common-slider__step .ba-common-slider__track{margin-left:calc(12px / 2)}.ba-common-slider__container__input.is-medium::-webkit-slider-thumb{width:18px;height:18px}.ba-common-slider__container__input.is-medium::-ms-thumb{height:18px;width:18px}.ba-common-slider__container__input.is-medium::-moz-range-thumb{width:18px;height:18px}.ba-common-slider__container__input.is-medium .ba-common-slider__handle__input{width:18px;height:18px}.ba-common-slider__container__input.is-medium .ba-common-slider__handle__input.is-focus{box-shadow:0 0 0 2px #a8c0f3;box-shadow:0 0 0 2px var(--focus, #a8c0f3);-webkit-box-shadow:0 0 0 2px var(--focus, #a8c0f3);-moz-box-shadow:0 0 0 2px var(--focus, #a8c0f3)}.ba-common-slider__container__input.is-medium .ba-common-slider__step{width:calc(100% - 18px)}.ba-common-slider__container__input.is-medium .ba-common-slider__step .ba-common-slider__track{margin-left:calc(18px / 2)}.ba-common-slider__container__input::-ms-track{height:2px;color:transparent;border:0}.ba-common-slider__container__input::-moz-range-progress{height:2px}.ba-common-slider__container__input::-moz-range-track{height:2px}.ba-common-slider__container__input::-moz-focus-outer{border:0}.ba-common-slider__container__input::-ms-tooltip{display:none}.ba-common-slider__container.is-disabled>input{cursor:not-allowed}.ba-common-slider__container .ba-common-slider__handle_label_container{margin-left:auto;margin-right:auto;margin-bottom:8px;width:91%}.ba-common-slider__container .ba-common-slider__handle_label_container.is-range{position:relative;height:18px;margin-left:9px}.ba-common-slider__container .ba-common-slider__handle_label_container .ba-common-slider__handle_label{display:inline-block;transform:translate(-50%);font-size:20px}.ba-common-slider__container .ba-common-slider__handle_label_container .ba-common-slider__handle_label.is-range{position:absolute}.ba-common-slider__container.is-boundaryLabelled{margin:0px 8px}.ba-common-slider__container.is-handleLabelled{height:52px}.ba-common-slider__preBar{position:absolute;height:2px;line-height:2px;z-index:200;border-radius:2px;padding:0px;margin:0px;pointer-events:none;top:7px}.is-handleLabelled .ba-common-slider__preBar{top:39px}.ba-common-slider__boundary_label{font-family:'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace;font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.32px;display:flex;align-self:flex-end;display:inline-block}.ba-common-slider__tooltip_trigger{height:18px;width:18px;background:transparent;position:absolute;z-index:-1}[dir=rtl] .ba-common-slider__handle_label{transform:translate(50%) !important}.ba-common-slider__container input{background:#e0e0e0}.ba-common-slider__container input::-webkit-slider-thumb{background-color:#161616}.ba-common-slider__container input::-moz-range-thumb{background-color:#161616}.ba-common-slider__container input::-ms-thumb{background-color:#161616}.ba-common-slider__container input::-ms-track{background-color:#161616}.ba-common-slider__container input::-ms-fill-lower{background-color:#161616}.ba-common-slider__container input::-ms-fill-upper{background-color:#161616}.ba-common-slider__container input::-moz-range-track{background:#e0e0e0}.ba-common-slider__container input::-moz-range-progress{background-color:#161616}.ba-common-slider__container input::-moz-range-track{background:#e0e0e0}.ba-common-slider__container input::-ms-fill-lower{background-color:#161616}.ba-common-slider__container input::-ms-fill-upper{background:#e0e0e0}@media screen and (-ms-high-contrast: active){.ba-common-slider__container input::-ms-fill-upper{background:#fff}}.ba-common-slider__container__input.is-range .ba-common-slider__rail{background:linear-gradient(to bottom, transparent 0, transparent 8px, #e0e0e0, #e0e0e0 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__rail.is-inverted{background:linear-gradient(to bottom, transparent 0, transparent 8px, #161616, #161616 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input{background:linear-gradient(to bottom, transparent 0, transparent 8px, #161616, #161616 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input.is-inverted{background:linear-gradient(to bottom, transparent 0, transparent 8px, #e0e0e0, #e0e0e0 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input{background-color:#161616}.ba-common-slider__container .ba-common-slider__handle_label_container{color:#393939}.ba-common-slider__container.is-focus{box-shadow:0 0 0 2px #a8c0f3;-webkit-box-shadow:0 0 0 2px #a8c0f3;-moz-box-shadow:0 0 0 2px #a8c0f3}.ba-common-slider__container.is-disabled{opacity:.5}@media screen and (-ms-high-contrast: active){.ba-common-slider__container.is-disabled input::-ms-fill-lower{background:#fff}}.ba-common-slider__preBar{background-color:#0f62fe}@supports(-ms-ime-align: auto){.ba-common-slider input{height:20px}.ba-common-slider input{background:transparent}}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.ba-common-slider input{height:20px}.ba-common-slider input{background:transparent}}", ""]);

// exports
exports.locals = {
	"sliderClassName": "\"ba-common-slider\"",
	"rangeSliderFlag": "\"is-range\"",
	"carbonContainer": "\"__carbonContainer\"",
	"primaryColor": "#161616",
	"neutralLightColor": "#e0e0e0"
};

/***/ }),

/***/ 6696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61376);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slider_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 46517:
/***/ ((module) => {

"use strict";
module.exports = require("lodash");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 11880:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__11880__;

/***/ }),

/***/ 65391:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__65391__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(56751));
/******/ return __webpack_exports__;
/******/ }
]);
});